import { ALL_AWARDS_QUERY_KEY } from '@tenant/awards/usePaginatedAwardsData'
import { TIMELINE_ITEMS_QK } from '@tenant/home/user/timeline/useTimelineItems'
import { PINNED_TIMELINE_ITEMS_QK } from '@tenant/home/user/upcomingAndImportantSection/usePinnedTimelineItems'
import { MY_TIMELINE_ITEMS_QK } from '@tenant/me/myTimeline/useMyTimelineItems'
import { MEMBER_TIMELINE_ITEMS_QK } from '@tenant/memberProfile/useMemberTimelineItems'
import { AWARDS_SUMMARY_QK } from '@tenant/me/useAwardsSummary'
import { ALL_RECOGNITION_QK } from '@tenant/recognition/recognitionQueryKeys'
import { SPACE_POSTS_TIMELINE_QK } from '@tenant/spaces/space/spaceTimeline/useSpaceTimelineItems'
import { GET_SPACE_POST_QK } from '@tenant/spaces/space/spacesWallPosts/useGetSpacePost'
import { MEMBER_QUALITY_STATS_QK } from '@shared/qualities/useMemberQualityStats'
import { MEMBER_ALL_TIME_STATS_QK } from '@shared/timeline/member/summary/useMemberRecognitionSummary'
import { EntityType } from './useTimelineCacheUpdater'

// Shared timeline query keys that should be updated when posts change
export const TIMELINE_QUERY_KEYS = [
  [TIMELINE_ITEMS_QK],
  [MY_TIMELINE_ITEMS_QK],
  [MEMBER_TIMELINE_ITEMS_QK],
  [PINNED_TIMELINE_ITEMS_QK],
  [SPACE_POSTS_TIMELINE_QK],
  // The profile summary tiles count recognition and awards and leave out flagged
  // items, so flagging or deleting a post changes them — and the qualities it
  // was tagged with — too.
  [MEMBER_ALL_TIME_STATS_QK],
  [MEMBER_QUALITY_STATS_QK],
] as const

// Entity-specific query keys
export const RECOGNITION_QUERY_KEYS = [[ALL_RECOGNITION_QK]] as const

// Badge summaries exclude flagged awards, so award changes (e.g. flagging) must
// invalidate the awards summary cache to keep badges in sync on the profile pages.
export const AWARD_QUERY_KEYS = [[ALL_AWARDS_QUERY_KEY], [AWARDS_SUMMARY_QK]] as const

export const SPACE_POST_QUERY_KEYS = [[GET_SPACE_POST_QK]] as const
// Helper function to get all query keys for a specific entity type
export const getQueryKeysForEntity = (entityType: EntityType) => {
  const baseKeys = [...TIMELINE_QUERY_KEYS]

  if (entityType === 'recognition') {
    return [...baseKeys, ...RECOGNITION_QUERY_KEYS]
  } else if (entityType === 'award') {
    return [...baseKeys, ...AWARD_QUERY_KEYS]
  } else if (entityType === 'post') {
    return [...baseKeys, ...SPACE_POST_QUERY_KEYS]
  }

  return baseKeys
}
